import React from 'react';
import createIcon from '../utils/createIcon';

const ChevronLeftIcon = createIcon(
  <path d="M14 6L8 12L14 18" strokeLinecap="round" strokeLinejoin="round" />,
  'ChevronLeft'
);

export default ChevronLeftIcon;
